const events = require("./userLoadEvents.js");

const userLoadHandlers = {
    [events.Loading.Name](prev, event) {
        const update = {
            User: {
                Data: null,
                IsLoading: true,
                Error: null
            }
        };

        const result = Object.assign({}, prev, update);

        return result;
    },
    [events.Loaded.Name](prev, event) {
        const update = {
            User: {
                Data: event.Data,
                IsLoading: false,
                Error: null
            }
        };

        const result = Object.assign({}, prev, update);

        return result;
    },
    [events.LoadErrored.Name](prev, event) {
        const update = {
            User: {
                Data: null,
                IsLoading: true,
                Error: event.Error
            }
        };

        const result = Object.assign({}, prev, update);

        return result;
    }
};

module.exports = userLoadHandlers;


// WEBPACK FOOTER //
// ./src/events/userLoad/userLoadHandlers.js